import _Layout from "@arco-design/web-react/es/Layout";
import _Spin from "@arco-design/web-react/es/Spin";
import _Modal from "@arco-design/web-react/es/Modal";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import React, { useEffect } from 'react';
import Nav from './common/nav';
import lazyload from '@src/utils/lazyload';
import { Switch, Route } from 'react-router';
import { listStyle } from '@api/style';
import { useDispatch, useSelector } from 'react-redux';
import Menu from './common/menu';
import useMenus, { RouterContext } from './routers';
import style from './style/page.less';
import { checkColorConfig, updateColorConfig } from '@src/utils/api/common';
import usePreviewVersion from '@src/hooks/usePrviewVersion';
import useGlobalNotify from '@src/hooks/useGlobalNotify';
import ThemeEdit from '@src/pages/common/themeEdit';
var Setting = lazyload(function () {
  return import('./setting');
});
var Feedback = lazyload(function () {
  return import('../common/feedback');
});
var Page = function Page() {
  var dispatch = useDispatch();
  var _a = useSelector(function (state) {
      return {
        showSider: state.theme.showSider,
        themeConfig: state.theme.themeConfig
      };
    }),
    showSider = _a.showSider,
    themeConfig = _a.themeConfig;
  var themeId = themeConfig.themeId;
  var _b = useMenus(themeId),
    routers = _b.routers,
    ready = _b.ready,
    refresh = _b.refresh;
  var isPreview = usePreviewVersion().isPreview;
  var _c = useSelector(function (state) {
      return {
        themeInfo: state.theme.themeConfig,
        readonly: !state.theme.themeConfig.isMine,
        themeMode: state.theme.themeMode
      };
    }),
    themeInfo = _c.themeInfo,
    readonly = _c.readonly;
  useGlobalNotify(themeId);
  useEffect(function () {
    var getAllStyle = function getAllStyle() {
      return __awaiter(void 0, void 0, void 0, function () {
        var savedStyles, npmStyle_1, styles;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              savedStyles = {};
              if (!isPreview) return [3, 1];
              npmStyle_1 = window.__npmStyle__;
              Object.keys(npmStyle_1).forEach(function (key) {
                savedStyles[key] = {
                  version: npmStyle_1[key].version,
                  code: npmStyle_1[key].less
                };
              });
              return [3, 3];
            case 1:
              return [4, listStyle({
                themeId: themeId
              })];
            case 2:
              styles = _a.sent();
              styles.forEach(function (custom) {
                savedStyles[custom.component] = {
                  code: custom.code,
                  version: custom.version
                };
              });
              _a.label = 3;
            case 3:
              dispatch({
                type: 'updateStyle',
                payload: {
                  savedStyles: savedStyles
                }
              });
              return [2];
          }
        });
      });
    };
    getAllStyle();
    checkColorConfig({
      themeId: themeId
    }).then(function (result) {
      if (!result.ok) {
        _Modal.warning({
          closable: false,
          maskClosable: false,
          title: '提示',
          content: '你好，色彩配置新增了功能色【链接色】，点击确定按钮即可应用哦！',
          onOk: function onOk() {
            return __awaiter(void 0, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2, updateColorConfig({
                  themeId: Number(themeId)
                }).then(function () {
                  location.reload();
                })];
              });
            });
          }
        });
      }
    });
  }, []);
  if (!ready) {
    return /*#__PURE__*/React.createElement(_Spin, {
      className: "align-loading"
    });
  }
  return /*#__PURE__*/React.createElement(_Layout, {
    className: style.page
  }, /*#__PURE__*/React.createElement(_Layout.Header, {
    className: style.nav
  }, /*#__PURE__*/React.createElement(Nav, null)), /*#__PURE__*/React.createElement(RouterContext.Provider, {
    value: {
      refresh: refresh
    }
  }, /*#__PURE__*/React.createElement(_Layout.Content, {
    className: style.content
  }, /*#__PURE__*/React.createElement(Menu, {
    routers: __assign({}, routers),
    baseUrl: "/" + themeId + "/"
  }), /*#__PURE__*/React.createElement("main", {
    className: style.main,
    style: {
      paddingRight: showSider ? 288 : ''
    }
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/:themeId",
    component: Setting
  }))))), /*#__PURE__*/React.createElement(Feedback, null), /*#__PURE__*/React.createElement(ThemeEdit, {
    theme: themeInfo,
    readonly: readonly
  }, ' '));
};
export default Page;